// =============================================================================
// Sesión de autenticación (hallazgo S3)
// -----------------------------------------------------------------------------
// El access token vive en MEMORIA (nunca en localStorage en claro). Para resistir
// un reload de la misma pestaña (p. ej. el cambio de sucursal, que recarga la
// app) se persiste CIFRADO vía SecureStorage con la clave aleatoria por pestaña
// (S2): al cerrar la pestaña, la clave y los datos se destruyen.
// El refresh token (rotación con POST /refresh según el backend) también se
// guarda cifrado, nunca en claro.
// =============================================================================
import { SecureStorage } from '@/utils/secureStorage';

const TOKEN_KEY = 'frontline_token';
const REFRESH_KEY = 'frontline_refresh';
const USER_KEY = 'frontline_user';
const PERMISSIONS_KEY = 'frontline_permissions';
const BRANCHES_KEY = 'frontline_allowed_branches';

// Token vivo del proceso actual.
let accessToken = null;
let refreshToken = null;

export const session = {
  /**
   * Persiste la sesión completa (respuesta de POST /login o POST /refresh).
   * @param {{ token?: string, refresh_token?: string, user?: object,
   *          permissions?: string[], branches?: Array<number> }} data
   */
  setSession({ token, refresh_token, user, permissions, branches } = {}) {
    accessToken = token || null;
    refreshToken = refresh_token || null;

    if (accessToken) SecureStorage.setItem(TOKEN_KEY, accessToken);
    else SecureStorage.removeItem(TOKEN_KEY);
    if (refreshToken) SecureStorage.setItem(REFRESH_KEY, refreshToken);
    else SecureStorage.removeItem(REFRESH_KEY);

    if (user) SecureStorage.setItem(USER_KEY, user);
    if (permissions !== undefined && permissions !== null) {
      SecureStorage.setItem(PERMISSIONS_KEY, permissions);
    }
    if (branches !== undefined && branches !== null) {
      SecureStorage.setItem(BRANCHES_KEY, branches);
    }
  },

  /** Devuelve el access token (restaurado cifrado si hubo reload en la misma pestaña). */
  getAccessToken() {
    if (accessToken) return accessToken;
    accessToken = SecureStorage.getItem(TOKEN_KEY) || null;
    return accessToken;
  },

  getRefreshToken() {
    if (refreshToken) return refreshToken;
    refreshToken = SecureStorage.getItem(REFRESH_KEY) || null;
    return refreshToken;
  },

  /** Compatibilidad con el nombre usado por los interceptores de client.js. */
  getToken() {
    return this.getAccessToken();
  },

  isAuthenticated() {
    return !!this.getAccessToken();
  },

  getUser() {
    return SecureStorage.getItem(USER_KEY);
  },

  getPermissions() {
    return SecureStorage.getItem(PERMISSIONS_KEY) || [];
  },

  hasPermission(code) {
    return this.getPermissions().includes(code);
  },

  /** Limpieza local de la sesión (memoria + almacenamiento cifrado por pestaña). */
  clearLocal() {
    accessToken = null;
    refreshToken = null;
    SecureStorage.clear();
  },
};